import { Logo as VGLogo } from "@avanadeits/vangogh";

const Logo = (): JSX.Element => {
  return <VGLogo src="/img/logo/Avanade-Signature-Color.svg">Accenture ID Provisioning</VGLogo>;
};

export default Logo;
